import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./axios";
import vuetify from "./plugins/vuetify";
import style from "./style/style.scss";
import validations from "@/utils/validations";
import "./utils/filters";
import VueNumeric from "vue-numeric-currency";
import vueDebounce from "vue-debounce";
import VueTheMask from "vue-the-mask";
import global from "./store/global";
import i18n from "@/libs/i18n";
import VueSweetalert2 from "vue-sweetalert2";
import genericService from "@/services/genericService";
import VueQRCodeComponent from "vue-qrcode-component";
import roleAuthMixin from "@/mixins/roleAuth";
import { errorHandlerMixin } from "@/mixins/errorHandler";

// Global mixins
Vue.mixin(roleAuthMixin);
Vue.mixin(errorHandlerMixin);

// import Toast from "vue-toastification";
// Vue.use(Toast, {
//     transition: "Vue-Toastification__bounce",
//     maxToasts: 5,
//     newestOnTop: true,
//     position: "top-right",
// });

Vue.use(VueSweetalert2);

Vue.use(VueTheMask);
Vue.prototype.$phoneMask = "+964 #### ### ####";
Vue.prototype.$birthDate = "####/##/##";
Vue.prototype.$money = "#,###.##";
Vue.use(vueDebounce);
Vue.use(VueNumeric);
Vue.component("qr-code", VueQRCodeComponent);

Vue.prototype.$http = axios;
Vue.prototype.$validations = validations;
Vue.prototype.$global = global;
Vue.prototype.$genericService = genericService;

Vue.config.productionTip = false;
Vue.prototype.$eventBus = new Vue();

Vue.component("Loading", () => import("./components/Loading.vue"));
Vue.component("Pagination", () => import("./components/Pagination.vue"));

// Global error handler for Vue errors
Vue.config.errorHandler = function (err, vm, info) {
    console.error("Vue error:", err, info);

    // Show error toast for unexpected Vue errors
    if (store) {
        store.dispatch("toastification/setToast", {
            message: "حدث خطأ غير متوقع في التطبيق",
            type: "error",
        });
    }
};

// Initialize authentication state on app startup
const token = localStorage.getItem("accessToken");
if (token) {
    store.dispatch("auth/login");
}

new Vue({
    router,
    store,
    i18n,
    vuetify,
    style,
    render: (h) => h(App),
}).$mount("#app");
